/**
 * Utilitários de validação para formulários
 */

/**
 * Valida se a senha é forte
 * Deve ter pelo menos 8 caracteres, incluindo maiúsculas, minúsculas e caracteres especiais
 */
export function validarSenhaForte(senha) {
  if (!senha || senha.length < 8) {
    return {
      valida: false,
      mensagem: 'A senha deve ter pelo menos 8 caracteres'
    };
  }

  const temMaiuscula = /[A-Z]/.test(senha);
  const temMinuscula = /[a-z]/.test(senha);
  const temNumero = /[0-9]/.test(senha);
  const temEspecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(senha);

  if (!temMaiuscula) {
    return {
      valida: false,
      mensagem: 'A senha deve conter pelo menos uma letra maiúscula'
    };
  }

  if (!temMinuscula) {
    return {
      valida: false,
      mensagem: 'A senha deve conter pelo menos uma letra minúscula'
    };
  }

  if (!temNumero) {
    return {
      valida: false,
      mensagem: 'A senha deve conter pelo menos um número'
    };
  }

  if (!temEspecial) {
    return {
      valida: false,
      mensagem: 'A senha deve conter pelo menos um caractere especial'
    };
  }

  return {
    valida: true,
    mensagem: 'Senha forte'
  };
}

/**
 * Remove caracteres não numéricos de uma string
 */
function apenasNumeros(str) {
  return str.replace(/\D/g, '');
}

/**
 * Valida CPF
 */
function validarCPF(cpf) {
  cpf = apenasNumeros(cpf);
  
  if (cpf.length !== 11) return false;
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpf)) return false;
  
  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;
  
  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(10))) return false;
  
  return true;
}

/**
 * Valida CNPJ
 */
function validarCNPJ(cnpj) {
  cnpj = apenasNumeros(cnpj);
  
  if (cnpj.length !== 14) return false;
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{13}$/.test(cnpj)) return false;
  
  // Validação do primeiro dígito verificador
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) return false;
  
  // Validação do segundo dígito verificador
  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(1))) return false;
  
  return true;
}

/**
 * Valida CPF ou CNPJ
 */
export function validarCpfCnpj(documento) {
  if (!documento) {
    return {
      valido: false,
      mensagem: 'CPF/CNPJ é obrigatório'
    };
  }

  const apenasNum = apenasNumeros(documento);
  
  if (apenasNum.length === 11) {
    if (validarCPF(apenasNum)) {
      return {
        valido: true,
        tipo: 'CPF',
        mensagem: 'CPF válido'
      };
    } else {
      return {
        valido: false,
        mensagem: 'CPF inválido'
      };
    }
  } else if (apenasNum.length === 14) {
    if (validarCNPJ(apenasNum)) {
      return {
        valido: true,
        tipo: 'CNPJ',
        mensagem: 'CNPJ válido'
      };
    } else {
      return {
        valido: false,
        mensagem: 'CNPJ inválido'
      };
    }
  } else {
    return {
      valido: false,
      mensagem: 'CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos'
    };
  }
}

/**
 * Formata CPF ou CNPJ
 */
export function formatarCpfCnpj(documento) {
  const apenasNum = apenasNumeros(documento);
  
  if (apenasNum.length <= 11) {
    // Formatar como CPF
    return apenasNum.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else {
    // Formatar como CNPJ
    return apenasNum.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
}

